import React from 'react';
import cn from 'classnames';

import styles from './style.scss';

interface Props extends React.LiHTMLAttributes<HTMLLIElement> {
  children: React.ReactNode;
  className?: string;
}

const DefaultListItem = ({ children, className, ...restProps }: Props) => (
  <li className={cn(className, styles.item)} {...restProps}>
    {children}
  </li>
);

export default DefaultListItem;
